import { useQuery } from '@apollo/client';
import { BLOG_CATEGORIES } from '../../../../lib/query';
import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';

const ProductType = () => {
  const { loading, error, data: getCategories } = useQuery(BLOG_CATEGORIES);
  const [categories, setCategories] = useState([]);
  const {
    register,
    formState: { errors }
  } = useFormContext();

  const [addCategory, setAddCategory] = useState(false);
  const [newCategory, setNewCategory] = useState('');

  useEffect(() => {
    if (getCategories && getCategories.categories) {
      setCategories(getCategories.categories);
    }
  }, [getCategories]);

  const handleFieldChange = e => {
    setNewCategory(e.target.value);
  };

  const handleAddCategory = () => {
    if (newCategory) {
      setCategories([...categories, newCategory]);
      setNewCategory('');
    }
  };

  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Категори
      </Card.Header>
      <Card.Body>
        <Row className="gx-2 gy-3">
          <Col md="12">
            <Form.Group>
              <Form.Label>Категори сонгох</Form.Label>
              <Form.Select
                {...register(`category`)}
                isInvalid={!!errors.category}
              >
                <option value="">сонголт</option>
                {categories.map((category, i) => (
                  <option key={i} value={category}>
                    {category}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.category?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md="12" style={{ textAlign: 'right' }}>
            <Link onClick={() => setAddCategory(!addCategory)}>
              <h6 className="text-primary">Категори нэмэх</h6>
            </Link>
            {addCategory && (
              <Form.Group>
                <Form.Control
                  value={newCategory}
                  name="newCategory"
                  onChange={handleFieldChange}
                  type="text"
                  placeholder="Категори нэмэх"
                  onBlur={handleAddCategory}
                />
                {errors.additionalCategory && (
                  <Form.Control.Feedback type="invalid">
                    {errors.additionalCategory.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ProductType;
